import MyHeader from "./MyHeader";
import MyFooter from "./MyFooter";
import React from 'react'

const Layout = ({ children}) => {
  return (
    <React.Fragment>
      <MyHeader></MyHeader>
      <main>{children}</main>
      <MyFooter></MyFooter>
    </React.Fragment>
  );
}

export default Layout;